import { MessageHandler } from '../../ChatUserMessage.types';

export const defaultMessageHandler: MessageHandler = {
  submit: (args) => ({
    role: 'user' as const,
    content: args.text || '',
    parts: [{ type: 'text', text: args.text || '' }],
  }),
};
